import { render } from "./Portal.vue?vue&type=template&id=4d3d56e2"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"
script.render = render

export default script